<div class="tabs-buttons-container">
  <button *ngFor="let button of buttons" (click)="selectButton(button)" [class.selected]="selectedButton === button">
    <i-tabler [name]="button.icon"></i-tabler>
    <span>{{button.text}}</span>
  </button>
  <div class="placeholder"></div>
</div>